import { render, staticRenderFns } from "./dropdownSideContent.vue?vue&type=template&id=5b6f09e9&scoped=true"
import script from "./dropdownSideContent.vue?vue&type=script&lang=js"
export * from "./dropdownSideContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6f09e9",
  null
  
)

export default component.exports